import _ from "underscore";
import { createStore } from "@evertrue/et-flux";
import SocialProfileSource from "./social-profile-source";
import Utils from "core/utils/utils"

const SocialProfileStore = createStore("SocialProfileStore", {
  getInitialState() {
    return {
      profiles: {},
      loading: false,
    };
  },

  registerActions() {
    this.on(SocialProfileSource.actions.fetchedProfile, this.respondToFetchedProfile);
    this.on(SocialProfileSource.actions.loading, loading => {
      this.setState({ loading });
    });
  },

  respondToFetchedProfile(contact_id, profile) {
    const updated_profiles = Utils.cloneData(this.getState("profiles"));
    updated_profiles[contact_id] = profile;
    this.setState({ profiles: updated_profiles });
  },

  api: {
    getSocialProfile(id) {
      return this.getState("profiles")[id];
    },

    getLoading() {
      return this.getState("loading");
    },
  },
});

export default SocialProfileStore;
